import { z } from 'zod/v4';

import { normalizeIndentWidgetArgs } from './indent-widget-args.normalization';
import { indentWidgetDataSchema } from './partial-indent-widget-data.schema';

/**
 * `data` stays OPTIONAL here — unlike text's `content` or image's `url`, a spacer with no settings
 * is a complete, meaningful request (40px, synchronized), so there is nothing to promote to
 * required.
 */
const createIndentWidgetObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to create the indent (spacer) widget in.'),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: indentWidgetDataSchema
        .optional()
        .describe('Spacer settings. Anything omitted falls back to a sane default (40px, synchronized).'),
});

export const createIndentWidgetArgsSchema = z.preprocess(normalizeIndentWidgetArgs, createIndentWidgetObjectSchema);
